import type { DamageType } from "../damageType";
import type { Thing } from "../thing";
import { BloodPool } from "../things/bloodPool";
import { Sound } from "../things/sounds/sound";
import { SoundId } from "../things/sounds/soundId";
import type { XY } from "../xy";
import { MobCorpse } from "./mobCorpse";

export abstract class OrganicMobCorpse extends MobCorpse {
	constructor(xy: XY) {
		super(xy);
	}

	protected onZeroHp(source: Thing | null, type: DamageType | null): void {
		super.onZeroHp(source, type);
		this.board!.addNonPhysicalThing(new Sound(SoundId.GORE_SPLAT, this.xy));
		this.board!.addThing(new BloodPool(this.xy));
	}
}
